import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const NoteIcon: FC<SvgProps> = ({ fill, ...props }) => {
    return (
        <Svg viewBox="0 0 16 16" height={16} width={16} {...props}>
            <Path
                fill={fill || ColorEnum.EMERALD_500}
                d="M3.447 12.552h9.104v-6.05L9.497 3.448h-6.05v9.104Zm0 1.583c-.436 0-.809-.155-1.119-.465a1.525 1.525 0 0 1-.465-1.118V3.448c0-.436.155-.809.465-1.119.31-.31.683-.465 1.119-.465h6.05a1.589 1.589 0 0 1 1.128.472l3.037 3.038a1.589 1.589 0 0 1 .472 1.128v6.05c0 .435-.155.808-.465 1.118-.31.31-.683.465-1.118.465H3.447Zm1.886-2.8h5.331c.189 0 .355-.071.498-.212a.68.68 0 0 0 .214-.5.688.688 0 0 0-.214-.502.683.683 0 0 0-.498-.214h-5.33a.683.683 0 0 0-.498.214.688.688 0 0 0-.214.502c0 .192.071.359.214.5a.687.687 0 0 0 .497.212Zm0-2.603h5.331a.683.683 0 0 0 .498-.215.687.687 0 0 0 .214-.501.687.687 0 0 0-.214-.502.683.683 0 0 0-.498-.214h-5.33a.683.683 0 0 0-.498.214.687.687 0 0 0-.214.502c0 .191.071.358.214.501a.683.683 0 0 0 .497.215ZM5.33 6.108h3.232a.672.672 0 0 0 .493-.214.691.691 0 0 0 .212-.502.691.691 0 0 0-.212-.501.672.672 0 0 0-.493-.215H5.33a.68.68 0 0 0-.494.215.687.687 0 0 0-.214.501c0 .192.071.359.214.502a.68.68 0 0 0 .494.214Z"
            />
        </Svg>
    )
}

export default NoteIcon
